module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "search",
    attrs: {
      "type": "text",
      "placeholder": "请输入品牌"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": _vm.filterBrand,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("常见品牌")]), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('inline-loading')], 1) : _vm._e(), _vm._v(" "), _c('group', _vm._l((_vm.filteredList), function(item) {
    return _c('cell', {
      key: item.brandId,
      attrs: {
        "title": item.spName
      },
      nativeOn: {
        "click": function($event) {
          _vm.gotoPanel(item)
        }
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58b9a044"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/device/tvBox/BrandList.vue
// module id = 898
// module chunks = 1